(function() {
  'use strict';
  
  angular
    .module('app.inflector', []);
  
})();